export const allowanceLimit = {
	sda: 1000000,
	fia: 10000000,
};
